import * as R from 'ramda';
import { put } from 'redux-saga/effects';
// feature sockets
import * as A from '../actions';
import * as C from '../constants';
//////////////////////////////////////////////////

const messageTypes = R.prop('trailerMessageType', C);

function* handleTrailerMessageReceived({ data, socketDataType }) {
  switch (socketDataType) {
    case messageTypes.trailerActivityListStatus:
      yield put(A.socketTrailerActivityStatusReceived(data));
      break;
    default:
  }
}

export default handleTrailerMessageReceived;
